import React from "react";
import { useSelector } from "react-redux";
import { IntlProvider } from "react-intl";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Box, Container } from "@mui/material";
import translations from "app/libs/i18n/translations.json";
/* Unified Login component — defaultUserType="recruiter" */
import Login from "bundles/Devise/Login/components/Login";
import AcceptInvitation from "bundles/Devise/LoginRecruiter/components/AcceptInvitation";
import MainAppBarRecruiter from "bundles/Layouts/MainAppBarRecruiter";
import ForgottenPassword from "bundles/common/components/ForgottenPassword";
import ChangePassword from "bundles/common/components/ChangePassword";
import ResendConfirmation from "bundles/common/components/ResendConfirmation";

const LoginRecruiterContainer = () => {
  const i18nLocale = useSelector((state) => state.i18nLocale);
  const locale = i18nLocale;
  const messages =
    translations[locale] || (locale === "fr-fr" ? translations.fr : {});

  return (
    <IntlProvider locale={locale} key={locale} messages={messages}>
      <BrowserRouter>
        <Routes>
          <Route
            path={`/${i18nLocale}/recruiters/sign_in`}
            element={<Login defaultUserType="recruiter" />}
          />

          {/* Utility auth pages */}
          <Route
            path={`/${i18nLocale}/recruiters/password/new`}
            element={
              <Box>
                <MainAppBarRecruiter />
                <Container maxWidth="sm" sx={{ mt: 8 }}>
                  <ForgottenPassword userType="recruiters" />
                </Container>
              </Box>
            }
          />
          <Route
            path={`/${i18nLocale}/recruiters/password/edit`}
            element={
              <Box>
                <MainAppBarRecruiter />
                <Container maxWidth="sm" sx={{ mt: 8 }}>
                  <ChangePassword userType="recruiters" />
                </Container>
              </Box>
            }
          />
          <Route
            path={`/${i18nLocale}/recruiters/confirmation/new`}
            element={<ResendConfirmation userType="recruiters" />}
          />
          <Route
            path={`/${i18nLocale}/recruiters/invitation/accept`}
            element={
              <Box>
                <MainAppBarRecruiter />
                <Container maxWidth="sm" sx={{ mt: 8 }}>
                  <AcceptInvitation />
                </Container>
              </Box>
            }
          />

          <Route
            path={`/${i18nLocale}`}
            element={<Navigate to={`/${i18nLocale}/recruiters/sign_in`} />}
          />
        </Routes>
      </BrowserRouter>
    </IntlProvider>
  );
};

export default LoginRecruiterContainer;
